import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CreateFormikVals, CsvFile } from '../../../fleets.model';

interface CreateFleetsState {
  currentFleets: string[];
  createdFleet: string | null;
  createFormData: CreateFormikVals | null;
  fleetName: string;
  fleetNameError: boolean;
  fleetFormVesselFieldError: boolean;
  createNewFleetSubmitted: boolean;
  createMode: number;
  resetStatic: boolean;
  resetManualForm: boolean;
  uploadedFiles: CsvFile[];
  isCreateFleetOpen: boolean;
  files: CsvFile[];
  formikValues: CreateFormikVals;
}

export const INITIAL_CREATE_FLEETS_STATE: CreateFleetsState = {
  currentFleets: [],
  createdFleet: null,
  createFormData: null,
  fleetName: '',
  fleetNameError: false,
  fleetFormVesselFieldError: true,
  createNewFleetSubmitted: false,
  createMode: 0,
  resetStatic: false,
  resetManualForm: false,
  uploadedFiles: [],
  isCreateFleetOpen: false,
  files: [],
  formikValues: { isCompanyList: false, vessels: [] },
};

const CreateFleetsDialogSlice = createSlice({
  name: 'fleets',
  initialState: INITIAL_CREATE_FLEETS_STATE,
  reducers: {
    setCurrentFleets: (state, action: PayloadAction<string[]>) => {
      state.currentFleets = action.payload;
    },
    setCreatedFleet: (state, action: PayloadAction<string | null>) => {
      state.createdFleet = action.payload;
    },
    setCreateFormData(state, action: PayloadAction<CreateFormikVals | null>) {
      state.createFormData = action.payload;
    },
    setFleetName(state, action: PayloadAction<string>) {
      state.fleetName = action.payload;
    },
    setFleetNameError(state, action: PayloadAction<boolean>) {
      state.fleetNameError = action.payload;
    },
    resetCreateState() {
      return INITIAL_CREATE_FLEETS_STATE;
    },
    setStaticDataResetState(state, action: PayloadAction<boolean>) {
      state.resetStatic = action.payload;
    },
    setManualFormResetState(state, action: PayloadAction<boolean>) {
      state.resetManualForm = action.payload;
    },
    setFleetFormVesselFieldError(state, action: PayloadAction<boolean>) {
      state.fleetFormVesselFieldError = action.payload;
    },
    setCreateNewFleetSubmitted(state, action: PayloadAction<boolean>) {
      state.createNewFleetSubmitted = action.payload;
    },
    setCreateMode(state, action: PayloadAction<number>) {
      state.createMode = action.payload;
    },
    setUploadedFiles(state, action: PayloadAction<CsvFile[]>) {
      state.uploadedFiles = action.payload;
    },
    setIsCreateFleetOpen(state, action: PayloadAction<boolean>) {
      state.isCreateFleetOpen = action.payload;
    },
    setFiles(state, action: PayloadAction<CsvFile[]>) {
      state.files = action.payload;
    },
  },
});

export const {
  setCurrentFleets,
  setCreatedFleet,
  setCreateFormData,
  setFleetName,
  setFleetNameError,
  resetCreateState,
  setStaticDataResetState,
  setManualFormResetState,
  setFleetFormVesselFieldError,
  setCreateNewFleetSubmitted,
  setCreateMode,
  setUploadedFiles,
  setIsCreateFleetOpen,
  setFiles,
} = CreateFleetsDialogSlice.actions;

export default CreateFleetsDialogSlice.reducer;
